{
  "validation.maxAttachments": "Solo puedes adjuntar hasta {{max}} archivos.",
  "validation.minAttachments": "Se necesitan al menos {{min}} archivos adjuntos.",
  "validation.maxAttachmentSize": "Los archivos adjuntos no pueden superar los {{max}} megabytes.",
  "validation.attachmentListItemRequired": "Por favor, envíanos un archivo adjunto para \"{{categoría}}\".",
  "validation.attachmentListItemMaxAttachments": "Solo puedes subir hasta {{max}} archivos adjuntos para \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "Los archivos adjuntos de {{category}} no pueden superar los {{max}} megabytes.",
  "attachment.bsoCategory.DiagnosticReport": "Informe de diagnóstico",
  "attachment.bsoCategory.InvoiceDocument": "Documento de factura",
  "attachment.bsoCategory.ShippingDocument": "Documento de envío",
  "attachment.bsoCategory.Letter": "Carta",
  "attachment.bsoCategory.PictureReference": "Referencia de imagen",
  "attachment.bsoCategory.BugReport": "Informe de errores",
  "attachment.bsoCategory.Other": "Otro",
  "attachment.bsoCategory.Unclassified": "Sin clasificar",
  "attachment.bsoCategory.ServiceForms": "Formulario de servicio",
  "attachment.bsoCategory.RegistrationDocument": "Documento de registro",
  "attachment.bsoCategory.ShopInside": "Imagen del interior de la tienda",
  "attachment.bsoCategory.ShopImageMigration": "Migración de imágenes de la tienda",
  "attachment.bsoCategory.ShopImage": "Imagen de la fachada de la tienda",
  "attachment.uploadButton": "Sube {{category}}",
  "attachment.uploadDropdown": "Sube un archivo"
}